<template>
  <FormsCard>
    <img class="block mx-auto mb-6 w-32 sm:w-40 h-auto" src="@/assets/omind_logo.png" alt="oMind">
    <h2 class="text-center pb-5 text-xl sm:text-2xl">
      {{ $t('SuccessMcpOAuthComponent.title') }}
    </h2>
    <div class="text-[var(--color-orange)] text-6xl sm:text-9xl text-center mt-4">
      <font-awesome-icon icon="fa-circle-check"/>
    </div>
    <p class="text-center text-base sm:text-lg text-wrap mt-8 sm:mt-12">
      {{ $t('SuccessMcpOAuthComponent.instructions') }}
    </p>
    <p class="text-center text-base sm:text-lg text-wrap mt-4 text-gray-600">
      {{ $t('SuccessMcpOAuthComponent.closeHint') }}
    </p>
    <Button
      v-if="clientRedirect"
      type="button"
      class="btn-primary-accent mt-8 w-full sm:w-auto px-8 py-3 text-lg mx-auto block text-center"
      unstyled
      @click="openClientRedirect"
    >
      {{ $t('SuccessMcpOAuthComponent.openClient') }}
    </Button>
  </FormsCard>
</template>

<script>
import FormsCard from '../global/slots/FormsCard.vue';
import Button from 'primevue/button';
import NetworkAuth from '@/helpers/networking/NetworkAuth';

const MCP_OAUTH_HANDOFF_KEY = 'mcp_oauth_handoff';

export default {
  name: 'SuccessMcpOAuthComponent',
  components: {
    FormsCard,
    Button,
  },
  data() {
    return {
      clientRedirect: null,
    };
  },
  async mounted() {
    const handoffId = sessionStorage.getItem(MCP_OAUTH_HANDOFF_KEY);
    sessionStorage.removeItem(MCP_OAUTH_HANDOFF_KEY);
    if (!handoffId) {
      return;
    }
    try {
      const { data } = await NetworkAuth.exchangeMcpOAuthHandoff(handoffId);
      if (data?.redirectUrl) {
        this.clientRedirect = data.redirectUrl;
        window.setTimeout(() => this.openClientRedirect(), 400);
      }
    } catch {
      this.$toast?.add?.({
        severity: 'error',
        summary: this.$t('SuccessMcpOAuthComponent.handoffFailed'),
        life: 5000,
      });
    }
  },
  methods: {
    openClientRedirect() {
      if (!this.clientRedirect) {
        return;
      }
      window.location.replace(this.clientRedirect);
    },
  },
};

</script>
